<template>
  <div class="zw-product-three-template">
    <!--    背景图-->
    <div
      :style="{backgroundImage:'url('+ bgImgUrl +')'}"
      class="zw-three-bg"
    >
      <div class="zw-three-bg-tile">
        <div>文化数字公共服务平台</div>
        <span>赋能文旅，构建数字文化公共服务</span>
      </div>
    </div>
    <div class="zw-three-bg-introduc">
      <div
        style="display: flex;justify-content: center;flex-direction: column;
        align-items: center;padding: 0 20px"
      >
        <div
          style="font-size: 28px;font-weight: bold;color: #000000;
         padding: 0 20px"
        >系统简介</div>
        <el-divider />
      </div>
      <div
        style="display: flex;padding: 50px 0 0;width: 100%;
      justify-content: center;flex-direction: column"
      >
        <div
          style="font-size: 16px;color: #000000;
        line-height: 26px"
        >
          该产品核心围绕传统文化传承和公共文化服务升级，打造“公众端 + 管理端”双端模式：公众端作为线上官网，
          让群众足不出户就能查看传统文化名录、免费开放项目、文化活动等内容；管理端实现线上内容维护、数据统计分析，
          大幅降低文化运营管理成本，最终构建集展示、管理、服务、传播于一体的数字化公共文化服务体系。
        </div>
      </div>
    </div>
    <div class="zw-three-bg-trait">
      <el-card shadow="always">
        <div
          style="font-size: 28px;font-weight: bold;color: #000000;
          text-align: center;padding: 20px 0"
        >系统特点</div>
        <div class="zw-trait-context">
          <ul>
            <li v-for="(item, index) in traitList" :key="index">
              <img v-if="index!==0" src="../../assets/image/product/fgf.png" alt="">
              <div
                style="display: flex;flex-direction: column;padding: 25px 40px;
                align-items: center;color: #4c5057;height: 100%;justify-content: space-around"
              >
                <img :src="item.imgUrl" height="96px" alt="">
                <div style="text-align: center;padding-top: 30px;color: #000000">
                  {{ item.text }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </el-card>
    </div>
    <!--免费获取方案-->
    <div
      :style="{backgroundImage:'url('+ fontImg +')'}"
      class="zw-three-footer"
    >
      <div
        style="display: flex;align-items: center;height: 100%;
      justify-content: center;flex-direction: column"
      >
        <div style="font-size: 28px;font-weight: bold;color: #000000;padding-bottom: 30px">
          即刻为你的企业定制解决方案
        </div>
        <el-button class="depth" size="small" type="danger" @click="handleProgramme">免费获取方案</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HumanNuclear',
  data() {
    return {
      bgImgUrl: require('../../assets/image/product/threeBg.jpg'),
      fontImg: require('../../assets/image/product/threeFoot.jpg'),
      traitList: [
        {
          imgUrl: require('../../assets/image/product/three01.png'),
          text: '双端协同模式：打造公众端 + 管理端，兼顾群众服务与后台管理；'
        },
        {
          imgUrl: require('../../assets/image/product/three02.png'),
          text: '传统文化聚焦：以传统文化传承为核心，实现文化资源线上展示；'
        },
        {
          imgUrl: require('../../assets/image/product/three03.png'),
          text: '高效管理降本：支持内容维护、数据统计，降低运营管理成本;'
        },
        {
          imgUrl: require('../../assets/image/product/three01.png'),
          text: '一体化体系：构建展示、管理、服务、传播于一体的数字化公共文化服务体系'
        }
      ]
    }
  },
  methods: {
    // 免费获取方案
    handleProgramme() {
      this.$router.push({
        path: '/getScheme'
      })
    }
  }
}
</script>

<style scoped>

</style>
